export default __webpack_public_path__ + "static/media/rosana-rodrigues.44bb9c42.jpg";